import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";
import { Computer, ConnectionData, RecordingTogglePayload, TokenResponse } from "../../interfaces/EndpointInterfaces";



export const manageComputer = async (tenantName: string, deviceId: string, roleList: string[]) => {
  const url = `${NGROK}/api/${tenantName}/manage-computer?computerId=${deviceId}&rolesList=${roleList}`;
  const data = await apiClient({
    method: "PUT",
    url,
  });
  return data;
}

const isDeviceWindows = (device: Computer): boolean => {
  if (device.OperatingSystem && device.OperatingSystem.trim().length > 0) {
    return device.OperatingSystem.toLowerCase().includes("windows");
  }
  return false;
};

export const createGuacConnection = async (
  computer: Computer,
  mode?: string,
  label?: string,
  role?: string,
  userApprovedNotifications: any[] = []
): Promise<ConnectionData | null> => {
  try {
    let payload: Record<string, any> = {
      computerId: computer.id,
      selectedTime: computer.accessRemainingTime,
    };

    if (
      role !== "user" &&
      (isDeviceWindows(computer) || Boolean(mode || label))
    ) {
      payload = { ...payload, connectMode: mode, label };
    } else if (
      role === "user" &&
      (isDeviceWindows(computer) || Boolean(mode || label))
    ) {
      const filteredData = userApprovedNotifications.filter(
        (item) =>
          Number(item.computerId) === Number(computer.id) &&
          item.requestStatus === "APPROVED" &&
          item.resourceType === "GROUP" &&
          item.resourceName === "Whiteswan Access"
      );

      const selectedMode = mode
        ? mode !== "generic"
          ? mode
          : null
        : filteredData?.[0]?.connectionMode && filteredData?.[0]?.connectionMode !== "generic"
          ? filteredData[0].connectionMode
          : null;

      const selectedLabel = label || filteredData?.[0]?.connectionLabel || "";

      if (selectedMode !== null || selectedLabel) {
        payload = {
          ...payload,
          connectMode: selectedMode,
          label: selectedLabel,
        };
      }
    }
    payload = { ...payload, userType: role };
    return await apiClient<ConnectionData>({
      method: "POST",
      url: `${NGROK}/api/guacamole/create-connection`,
      data: payload,
    });
  } catch (error) {
    console.error("createGuacConnection error:", error);
    return null;
  }
};

export const getToken = async (
  email: string,
  computerId: string,
  userRole: string
): Promise<TokenResponse | undefined> => {
  try {
    return await apiClient<TokenResponse>({
      method: "GET",
      url: `${NGROK}/api/access/${userRole}/get-token`,
      params: { email, computerId },
    });
  } catch (error) {
    console.error("getToken error:", error);
  }
};

export const saveToken = async (
  email: string,
  computer: Computer,
  userRole: string,
  userId: string
): Promise<TokenResponse | undefined> => {
  try {
    return await apiClient<TokenResponse>({
      method: "POST",
      url: `${NGROK}/api/access/${userRole}/save-token`,
      data: {
        email,
        computerId: computer.id,
        groupId: computer.whiteswanAccessGroupId,
        userId,
      },
    });
  } catch (error) {
    console.error("saveToken error:", error);
  }
};
export const toggleRecordingAPI = async (
  payload: RecordingTogglePayload,
  connectionData: ConnectionData | null
) => {
  try {
    return await apiClient({
      method: "PUT",
      url: `${NGROK}/api/guacamole/update-connection`,
      data: {
        url: `https://${payload.device?.guachost}`,
        id: connectionData?.id,
        enableRecordingPath: payload.recording,
        selectedTime: payload.device?.accessRemainingTime,

      },
    });
  } catch (error) {
    console.error("toggleRecordingAPI error:", error);
  }
};

export const toggleRecordingStatus = async (deviceId: string, tenantName: string) => {
  try {
    return await apiClient({
      method: "POST",
      url: `${NGROK}/api/recording-toggle/status?computerId=${deviceId}&tenantName=${tenantName}`,
    });
  }
  catch (error) {
    console.error("toggleRecordingStatus error:", error);
  }
}
